import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import "./index.css";

class AppointmentHomePage extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="Services">
        <section className="page-section" id="services">
          <div class="container">
            <div class="row">
              <div className="col-lg-12 text-center">
                <h2 className="section-heading text-uppercase">
                  {" "}
                  {t("appointmentPage.title")}
                </h2>
                <h3 className="section-subheading text-muted">
                  {t("appointmentPage.info")}
                </h3>
                </div>
                <div className="iframe-container">
                  <iframe
                    src="https://slotti.fi/booking/parturikknpori/"
                    title="Booking Page"
                    allowFullScreen
                  />
                </div>
              
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withTranslation("global")(AppointmentHomePage);
